import type { EventDispatcher } from "@optimizely/optimizely-sdk";

export const noOpDispatcher: EventDispatcher = {
  dispatchEvent: () => {
    // no-op
  },
};
